import { useEffect, useMemo } from 'react';

export interface KeyboardShortcutsInfo {
    shortcutsEnabled: boolean;
    submitLabel: string;
    cancelLabel?: string;
}

export const useFilterKeyboardShortcuts = (
    onSubmit: () => void,
    onCancel?: () => void,
    isOpen: boolean = true,
): KeyboardShortcutsInfo => {
    useEffect(() => {
        if (!isOpen) return undefined;

        const handleKeyDown = (event: KeyboardEvent) => {
            // Enter pour valider
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                onSubmit();
            }

            // Escape pour annuler (optionnel)
            if (event.key === 'Escape' && onCancel) {
                event.preventDefault();
                event.stopPropagation();
                onCancel();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onSubmit, onCancel, isOpen]);

    // Retourner les informations pour l'UI
    return useMemo(() => {
        const hasCancelButton = Boolean(onCancel);
        const shortcutsActive = isOpen;

        return {
            shortcutsEnabled: shortcutsActive,
            submitLabel: shortcutsActive ? 'Voir les résultats (↵)' : 'Voir les résultats',
            cancelLabel: hasCancelButton ? 'Fermer' : undefined,
        };
    }, [isOpen, onCancel]);
};
